import React from 'react';
import './PageTitle.scss';

export interface BreadcrumbItem {
  label: string;
  url?: string;
}

interface TitleProps {
  title: string;
  breadcrumbs?: never;
}

interface BreadcrumbProps {
  title?: never;
  breadcrumbs: BreadcrumbItem[];
}

type Props = TitleProps | BreadcrumbProps;

export default function PageTitle({ title, breadcrumbs }: Props) {
  return (
    <div className="page-title">
      {title ? (
        <h1 className="page-title__title">
          {title}
        </h1>
      ) : (
        <div className="page-title__breadcrumbs">
          {breadcrumbs?.map((item, index) => (
            <React.Fragment key={index}>
              {item.url ? (
                <a
                  href={item.url}
                  className="page-title__breadcrumbs__item"
                >
                  {item.label}
                </a>
              ) : (
                <span className="page-title__breadcrumbs__text">
                  {item.label}
                </span>
              )}
              {index < breadcrumbs.length - 1 && (
                <i className="pi pi-chevron-right page-title__breadcrumbs__separator" />
              )}
            </React.Fragment>
          ))}
        </div>
      )}
      <p className="page-title__sync-info">
        Última sincronização: {new Date().toLocaleString()}
      </p>
    </div>
  );
}
